const $thumbnails = $('.js-product-slider-thumbnails');

const sliderThumbs = {
  initialize() {
    if ($thumbnails.length) {
      this.activeSlide = 0;
      this.$slider = $($thumbnails.data('slider-target'));
      this.createEvents();
    }
  },

  createEvents() {
    $thumbnails.on('click', 'button', ({ currentTarget }) => {
      this.showSlide(currentTarget);
    });

    this.$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      this.activeSlide = nextSlide;
      this.handleStyles();
    });
  },

  showSlide(thumbEl) {
    const index = $(thumbEl).index();
    this.activeSlide = index;
    this.$slider.slick('goTo', index);
    this.handleStyles();
  },

  handleStyles() {
    const $children = $thumbnails.children();
    const $nonActive = $children.filter(`:not(:nth-child(${this.activeSlide + 1}))`);
    const $active = $children.eq(this.activeSlide);

    $nonActive.removeClass('is-active');
    $active.addClass('is-active');
  },
};

export default sliderThumbs;
